export default function (state, getters, rootState) {
    let sum = 0;
    rootState.finances.pay.form.AgreementCodes.forEach(i=>{
        sum += getters.sum_pay(getters.agreement(i));
    });
    return Math.round(sum * 100) / 100;
}